export default "__VITE_ASSET__B84yL$wM__"